import * as React from 'react'
import { IChatMessage } from '../../../model/chatmessage';
import { withStyles, StyledComponentProps, Paper, Typography } from '@material-ui/core';
import { styles } from '../styles';

interface IMessageItemProps extends StyledComponentProps {
    message: IChatMessage;
}
interface IMessageItemState {
}


class SingleMessage extends React.Component<IMessageItemProps, IMessageItemState> {
    render() {
        const classes = this.props.classes;
        const isMessageFromAdmin = this.props.message.fromAdmin;
        let dataMsg = new Date(this.props.message.createdAt);
        const dateFormatted = dataMsg.toDateString() + ` ` + dataMsg.toLocaleTimeString();
        return (
            <Paper className={isMessageFromAdmin ? classes.BubbleLeft : classes.BubbleRight}>
                <Typography className={classes.MsgTimestamp} color="textSecondary" gutterBottom>{dateFormatted}</Typography>
                <Typography style={{
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                }} variant="subtitle1" component="p">{this.props.message.text}</Typography>
            </Paper>
        );
    }
}

export const Message = withStyles(styles)(SingleMessage);

